var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { QboTemplate, template } from "@quandis/qbo4.configuration";
import { formatDate, qboui, QboFetchMixin } from '@quandis/qbo4.ui';
import { JSONPath } from 'jsonpath-plus';
export class QboActivity extends QboFetchMixin(QboTemplate) {
    constructor() {
        super(...arguments);
        this.jsonData = {};
        this.display = 25;
        this.start = 0;
        this.filename = 'ActivityLog.csv';
        this.searchFilter = false;
        this.show = true;
        this.title = 'Activity Log';
        this.type = 'activity';
        this.imagePath = window.qbo4['imagePath'] ?? '/ui/images/qbo-icons.svg';
    }
    static { this.styles = [
        qboui
    ]; }
    async paginate(e) {
        this.display = Number(e.detail['display']);
        this.start = Number(e.detail['start']);
    }
    async download(e) {
        const table = this.shadowRoot?.querySelector('table');
        let csvContent = "";
        // Process table rows
        const rows = table.querySelectorAll("tr");
        rows.forEach(row => {
            const cells = row.querySelectorAll("th, td");
            const rowContent = Array.from(cells)
                .map(cell => `"${cell.textContent?.replace(/"/g, '""') || ""}"`) // Escape double quotes
                .join(",");
            csvContent += rowContent + "\n";
        });
        // Create a Blob from the CSV string
        const blob = new Blob([csvContent], { type: "text/csv" });
        // Create a link to download the CSV file
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = this.filename;
        // Trigger the download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    filterKeyDown(e) {
        this.filterData = null;
        this.shadowRoot?.querySelectorAll('tr.qbo-filter').forEach(tr => {
            tr.querySelectorAll('input').forEach(input => {
                if (input instanceof HTMLInputElement && input.value.trim() != '') {
                    if (!this.filterData)
                        this.filterData = {};
                    this.filterData[input.name] = input.value;
                }
            });
        });
    }
    moduleLabel(module) {
        let result;
        switch (module) {
            case "Attachment":
                result = "Document";
                break;
            case "Decision":
                result = "Workflow";
                break;
            case "DecisionDelay":
                result = "Workflow Hold";
                break;
            case "DecisionStep":
                result = "Workflow Step";
                break;
            case "ImportForm":
                result = "Task";
                break;
            case "InsurancePolicy":
                result = "Insurance Policy";
                break;
            case "LedgerItem":
                result = "Ledger Item";
                break;
            case "ShortSale":
                result = "Short Sale";
                break;
            default:
                result = module;
        }
        return result;
    }
    renderDescription(item) {
        if (item?.BodyText)
            return `Message: ${item.BodyText}`;
        const changeType = item.CreatedDate == item.UpdatedDate ? 'added' : 'changed';
        const firstKeyLabel = Object.keys(item)[0].substring(0, Object.keys(item)[0].length - 2);
        if (firstKeyLabel === 'DecisionStep') {
            const moduleLabel = this.moduleLabel(item.Object);
            if (item.ActualCompletion)
                return `${item.DecisionStep} ${moduleLabel} for ${item.Decision} Workflow has completed`;
            else if (item.Status == 'Canceled')
                return `${item.DecisionStep} ${moduleLabel} for ${item.Decision} Workflow has been canceled`;
            else if (item.Status == 'Error')
                return `${item.DecisionStep} ${moduleLabel} for ${item.Decision} Workflow has an error`;
            else if (item.Status == 'Pending')
                return `${item.DecisionStep} ${moduleLabel} for ${item.Decision} Workflow is pending`;
            else if (item.Status == 'Queued')
                return `${item.DecisionStep} ${moduleLabel} for ${item.Decision} Workflow has been queued for processing`;
            else if (item.Status == 'Reprocessing')
                return `${item.DecisionStep} ${moduleLabel} for ${item.Decision} Workflow is reprocessing`;
            else if (item.Status == 'Started')
                return `${item.DecisionStep} ${moduleLabel} for ${item.Decision} Workflow has started`;
            else if (changeType == 'added')
                return `${item.DecisionStep} ${moduleLabel} ${changeType} by ${item.Decision} Workflow`;
            else
                return `${item.DecisionStep} ${moduleLabel} for ${item.Decision} Workflow ${changeType}`;
        }
        return `${item[firstKeyLabel]} ${this.moduleLabel(firstKeyLabel)} ${changeType}`;
    }
    renderModule(item, sorted) {
        const firstKeyLabel = Object.keys(item)[0].substring(0, Object.keys(item)[0].length - 2);
        let module = item.Object ?? firstKeyLabel;
        let moduleId = item.ObjectID ?? item[`${firstKeyLabel}ID`];
        if (firstKeyLabel == 'DecisionStep' || firstKeyLabel == 'DecisionDelay') {
            const workflow = sorted.find((element) => element.DecisionID == item.DecisionID && Object.keys(element)[0] == "DecisionID");
            module = workflow?.Object ?? module;
            moduleId = workflow?.ObjectID ?? moduleId;
        }
        let parent = sorted.find((element) => element && element[`${module}ID`] == moduleId && Object.keys(element)[0] == `${module}ID`);
        while (parent?.Object && parent?.ObjectID && !parent?.ProcessID) {
            module = parent.Object;
            moduleId = parent.ObjectID;
            parent = sorted.find((element) => element && element[`${module}ID`] == moduleId && Object.keys(element)[0] == `${module}ID`);
        }
        if (module == 'Borrower') {
            const borrower = sorted.find((element) => element && element.BorrowerID == moduleId && Object.keys(element)[0] == "BorrowerID");
            module = 'Loan';
            moduleId = borrower?.LoanID;
        }
        return `${this.moduleLabel(module)}`;
    }
    renderName(item, sorted) {
        const firstKeyLabel = Object.keys(item)[0].substring(0, Object.keys(item)[0].length - 2);
        let label = item[firstKeyLabel];
        let module = item.Object ?? firstKeyLabel;
        let moduleId = item.ObjectID ?? item[`${firstKeyLabel}ID`];
        if (firstKeyLabel == 'DecisionStep' || firstKeyLabel == 'DecisionDelay') {
            const workflow = sorted.find((element) => element.DecisionID == item.DecisionID && Object.keys(element)[0] == "DecisionID");
            module = workflow?.Object ?? module;
            moduleId = workflow?.ObjectID ?? moduleId;
        }
        let parent = sorted.find((element) => element && element[`${module}ID`] == moduleId && Object.keys(element)[0] == `${module}ID`);
        while (parent?.Object && parent?.ObjectID && !parent?.ProcessID) {
            module = parent.Object;
            moduleId = parent.ObjectID;
            parent = sorted.find((element) => element && element[`${module}ID`] == moduleId && Object.keys(element)[0] == `${module}ID`);
        }
        label = parent ? parent[module] ?? label : label;
        if (module == 'Borrower') {
            const borrower = sorted.find((element) => element && element.BorrowerID == moduleId && Object.keys(element)[0] == "BorrowerID");
            module = 'Loan';
            label = borrower?.Loan;
        }
        return `${label}`;
    }
    activity(component) {
        const descendants = JSONPath({ path: `$..*`, json: component.jsonData });
        let sorted = descendants ? descendants
            .filter(item => {
            if (item && typeof item === "object" && !Array.isArray(item)) {
                return Object.keys(item)[0] !== "ScoreItemID" && Object.keys(item)[0] !== "LedgerItemID";
            }
            return true;
        })
            .filter(item => {
            if (item && typeof item === "object" && !Array.isArray(item)) {
                return (Object.keys(item)[0] !== "ProcessID" || item['Sibling'] == null);
            }
            return true;
        })
            .filter(item => {
            if (item && typeof item === "object" && !Array.isArray(item)) {
                return (Object.keys(item)[0] !== "ImportFormID" || item['DecisionStepID'] == null);
            }
            return true;
        })
            .filter(item => item?.UpdatedDate)
            : [];
        const sortedNoFilter = sorted;
        if (component.filterData) {
            sorted = sorted
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Date) {
                    return formatDate(item.UpdatedDate)?.toLowerCase().includes(component.filterData.Date.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Time) {
                    return formatDate(item.UpdatedDate, 'HH:mm:ss')?.toLowerCase().includes(component.filterData.Time.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Description) {
                    return `${component.renderDescription(item)}`.toLowerCase().includes(component.filterData.Description.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.User) {
                    return item.UpdatedPerson?.toLowerCase().includes(component.filterData.User.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Module) {
                    return `${component.renderModule(item, descendants)}`.toLowerCase().includes(component.filterData.Module.toLowerCase());
                }
                return true;
            })
                .filter(item => {
                if (item && typeof item === "object" && !Array.isArray(item) && component.filterData.Name) {
                    return `${component.renderName(item, descendants)}`.toLowerCase().includes(component.filterData.Name.toLowerCase());
                }
                return true;
            });
        }
        sorted = sorted.sort((a, b) => new Date(b.UpdatedDate).getTime() - new Date(a.UpdatedDate).getTime());
        const count = sorted.length;
        const sortedList = count > component.display ? sorted.slice(component.start, component.start + component.display) : sorted;
        return html `<slot class=${component.show ? '' : 'collapse'}>
<h3 class="title">
    <button type="button" class="expandcollapse" @click="${(e) => component.show = !component.show}">
        <svg>
            <use href="${component.imagePath}#${component.show ? 'dash' : 'plus'}">
        </svg>
    </button>
    ${component.title}
</h3>
<div class="qbo-row qbo-row-padding-top">
    <div class="qbo-col qbo-col-noborder">
        <div class="qbo-card-buttons">
            <button type="button" class="${component.searchFilter ? 'active' : ''}" @click="${(e) => component.searchFilter = !component.searchFilter}">
                <svg>
                    <use href="${component.imagePath}#search">
                </svg>
                Search
                <qbo-popover>
                    <h3>Search</h3>
                    <p>Toggle the search options to locate specific activity.</p>
                </qbo-popover>
            </button>
            <button type="button" @click="${(e) => component.download(e)}">
                <svg>
                    <use href="${component.imagePath}#download">
                </svg>
                Download
                <qbo-popover>
                    <h3>Download</h3>
                    <p>Export displayed activity to csv.</p>
                </qbo-popover>
            </button>
        </div>
        <table class="qbo-nowrap" data-drop>
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Description</th>
                    <th>User</th>
                    <th>Module</th>
                    <th>Name</th>
                </tr>
            </thead>
            <tbody>
                ${component.searchFilter ? html `
                    <tr class="qbo-filter">
                        <td><input type="text" name="Date" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Time" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Description" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="User" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Module" @keyup=${component.filterKeyDown}></input></td>
                        <td><input type="text" name="Name" @keyup=${component.filterKeyDown}></input></td>
                    </tr>
                ` : html ``}
                ${sortedList ? sortedList.map(item => html `
                    <tr>
                        <td>${formatDate(item.UpdatedDate)}</td>
                        <td>${formatDate(item.UpdatedDate, 'HH:mm:ss')}</td>
                        <td>${item?.BodyText ? html `<span class="bodyText">${component.renderDescription(item)}</span>` : component.renderDescription(item)}</td>
                        <td>${item.UpdatedPerson}</td>
                        <td>${component.renderModule(item, sortedNoFilter)}</td>
                        <td>${component.renderName(item, sortedNoFilter)}</td>
                    </tr>
                `) : html `<tr><td colspan="6">No data available</td></tr>`}
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="6">${sortedList && sortedList[0] ? html `<qbo-paginate .count=${count} @change=${(e) => component.paginate(e)}></qbo-paginate>` : html ``}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
        </slot>`;
    }
}
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], QboActivity.prototype, "jsonData", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], QboActivity.prototype, "filterData", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboActivity.prototype, "display", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboActivity.prototype, "start", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboActivity.prototype, "filename", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboActivity.prototype, "searchFilter", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboActivity.prototype, "show", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboActivity.prototype, "title", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboActivity.prototype, "type", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboActivity.prototype, "imagePath", void 0);
__decorate([
    template('activity'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [QboActivity]),
    __metadata("design:returntype", void 0)
], QboActivity.prototype, "activity", null);
if (!customElements.get('qbo-activity'))
    customElements.define('qbo-activity', QboActivity);
